// tokenUtils.js
export const decodeToken = (token) => {
    if (!token) return null;

    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload;
    } catch (error) {
        console.error('Token dekódolási hiba:', error);
        return null;
    }
};

export const isTokenValid = (token) => {
    if (!token) return false;

    try {
        const payload = decodeToken(token);

        if (!payload || !payload.valid) {
            console.warn('Token nem tartalmaz lejárati időt vagy érvénytelen');
            return false;
        }

        // A 'valid' mező már milliszekundumban van a backend-ből
        const expirationTime = payload.valid;
        const currentTime = Date.now();

        return currentTime < expirationTime;
    } catch (error) {
        console.error('Token ellenőrzési hiba:', error);
        return false;
    }
};

export const getTokenTimeRemaining = (token) => {
    if (!token) return null;

    try {
        const payload = decodeToken(token);

        if (!payload || !payload.valid) {
            return null;
        }

        // A 'valid' mező már milliszekundumban van a backend-ből
        const expirationTime = payload.valid;
        const currentTime = Date.now();
        const remainingMs = expirationTime - currentTime;

        if (remainingMs <= 0) {
            return { expired: true, minutes: 0, seconds: 0 };
        }

        const minutes = Math.floor(remainingMs / 60000);
        const seconds = Math.floor((remainingMs % 60000) / 1000);

        return { expired: false, minutes, seconds, totalSeconds: Math.floor(remainingMs / 1000) };
    } catch (error) {
        console.error('Token idő számítási hiba:', error);
        return null;
    }
};